export default "__VITE_ASSET__BAgXZdsi__"